import clsx from "clsx";
import React from "react";
import styles from "./toggle.module.scss";

export const Toggle = React.forwardRef<
  HTMLInputElement,
  React.HTMLProps<HTMLInputElement> & {
    small?: boolean;
    reverse?: boolean;
    disabled?: boolean;
  }
>(
  (
    { small = false, reverse = false, disabled = false, className, ...props },
    ref
  ) => {
    return (
      <div
        className={clsx(
          styles.toggle_wrapper,
          {
            [styles.small]: small,
            [styles.reverse]: reverse,
            [styles.disabled]: disabled,
          },
          className
        )}
      >
        <label className={styles.toggle}>
          <input type="checkbox" ref={ref} disabled={disabled} {...props} />
          <span className={styles.slider}></span>
        </label>
        {props.label && (
          <span className={styles.toggle_text}>{props.label}</span>
        )}
      </div>
    );
  }
);

Toggle.displayName = "Toggle";
